import { render } from "./InfoModal.vue?vue&type=template&id=48958d3e"
import script from "./InfoModal.vue?vue&type=script&lang=js"
export * from "./InfoModal.vue?vue&type=script&lang=js"

import "./InfoModal.vue?vue&type=style&index=0&id=48958d3e&lang=css"

import exportComponent from "C:\\Users\\kiemp\\OneDrive\\Documents\\VSCode\\SMM2_info\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__